(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-content"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const wrap = button.closest('.cart-page__qty');
        const input = wrap && wrap.querySelector('[data-qty-input]');
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(button.dataset.qtyChange || 0));
        input.value = String(next);
      });
    });

    const clearLink = document.querySelector('[data-clear-cart]');
    if (clearLink) {
      clearLink.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = clearLink.getAttribute('href') || '/cart/clear';
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["floating-shop-cta"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-floating-shop]');
    if (!root) return;

    root.hidden = false;

    const onScroll = () => {
      root.classList.toggle('is-visible', window.scrollY > 420);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-content"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const status = gallery.querySelector('[data-gallery-status]');

      const activate = (thumb) => {
        const targetId = thumb.dataset.galleryTarget;
        slides.forEach((slide) => {
          slide.hidden = slide.id !== targetId;
        });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (status) status.textContent = thumb.getAttribute('aria-label') || '';
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activate(thumb));
        thumb.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % thumbs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + thumbs.length) % thumbs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = thumbs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          thumbs[nextIndex].focus();
          activate(thumbs[nextIndex]);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shop-card"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCard(card) {
      const planInputs = Array.from(card.querySelectorAll('input[data-plan-id]'));
      const priceEl = card.querySelector('[data-display-price]');
      const unitPriceEl = card.querySelector('[data-unit-price]');
      const recurring = card.querySelector('[data-recurring-note]');
      const savings = card.querySelector('[data-savings-label]');
      const planPanel = card.querySelector('[data-plan-panel]');
      const submit = card.querySelector('[data-submit-text]');
      const submitBtn = card.querySelector('.shop-card__submit');
      const onetimePrice = card.dataset.onetimePrice || '';
      const onetimeUnitPrice = card.dataset.onetimeUnitPrice || '';
      const defaultPlanPrice = card.dataset.defaultPlanPrice || onetimePrice;
      const defaultPlanUnitPrice = card.dataset.defaultPlanUnitPrice || onetimeUnitPrice;

      function selectedPlan() {
        return card.querySelector('input[data-plan-id]:checked');
      }

      function updateRecurring(plan) {
        if (!recurring) return;
        const timeline = plan && plan.dataset.planTimeline ? plan.dataset.planTimeline.trim() : '';
        const price = plan && plan.dataset.planPrice ? plan.dataset.planPrice.trim() : '';
        const fallback = recurring.dataset.recurringDefault || '';
        const template = recurring.dataset.recurringTemplate || '';
        if (timeline && price && template) {
          recurring.textContent = template.replace('__PRICE__', price).replace('__TIMELINE__', timeline);
        } else if (timeline) {
          recurring.textContent = timeline;
        } else {
          recurring.textContent = fallback;
        }
      }

      function setPurchase(type) {
        card.querySelectorAll('[data-purchase-option]').forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-purchase-option') === type);
        });
        if (planPanel) planPanel.classList.toggle('is-hidden', type !== 'subscription');
        if (recurring) recurring.classList.toggle('is-hidden', type !== 'subscription');
        if (type === 'subscription') {
          planInputs.forEach((input) => { input.disabled = false; });
          const plan = selectedPlan();
          if (priceEl) priceEl.textContent = plan ? plan.dataset.planPrice : defaultPlanPrice;
          if (unitPriceEl) unitPriceEl.textContent = plan ? plan.dataset.planUnitPrice : defaultPlanUnitPrice;
          if (savings && plan) savings.textContent = plan.dataset.planSavings || '';
          updateRecurring(plan);
        } else {
          planInputs.forEach((input) => { input.disabled = true; });
          if (priceEl) priceEl.textContent = onetimePrice;
          if (unitPriceEl) unitPriceEl.textContent = onetimeUnitPrice;
        }
        if (submit && submitBtn) {
          submit.textContent = type === 'subscription'
            ? submitBtn.dataset.submitLabelSub
            : submitBtn.dataset.submitLabelOne;
        }
      }

      card.querySelectorAll('[data-purchase-type]').forEach((input) => {
        input.addEventListener('change', () => setPurchase(input.value === 'subscription' ? 'subscription' : 'onetime'));
      });

      card.querySelectorAll('input[data-plan-id]').forEach((input) => {
        input.addEventListener('change', () => {
          card.querySelectorAll('.shop-card__plan').forEach((el) => el.classList.remove('is-active'));
          input.closest('.shop-card__plan')?.classList.add('is-active');
          if (priceEl) priceEl.textContent = input.dataset.planPrice || defaultPlanPrice;
          if (unitPriceEl) unitPriceEl.textContent = input.dataset.planUnitPrice || defaultPlanUnitPrice;
          if (savings) savings.textContent = input.dataset.planSavings || '';
          updateRecurring(input);
        });
      });

      const initial = card.querySelector('[data-purchase-type]:checked');
      setPurchase(initial && initial.value === 'subscription' ? 'subscription' : 'onetime');
    }

    document.querySelectorAll('[data-shop-card]').forEach(initCard);
  })();
  } catch(e) { console.error(e); }
})();

})();
